import { createAsyncThunk } from "@reduxjs/toolkit";
import { uploadedDocuments } from "../services/apiEndPoints";

export const fetchUploadedDocuments = createAsyncThunk(
  "preview/fetchUploadDocuments",
  async ({
    access_id,
    amenityCategory, 
  }: {
    access_id: string; 
    amenityCategory: number;
  }) => {
    try {
      const response = await uploadedDocuments({
        access_id: access_id,
        module_type: "access",
        category_id: amenityCategory,
      });  
      return response.data.data;
    } catch (error: any) {
      // return thunkAPI.rejectWithValue(
      //   error.response?.data || error.message || "Failed to load documents"
      // );
    }
  }
);
